import qs from 'qs';
import fetchWithDefaults from '../../CommonUtils/fetchWithDefaults';
import { dateToISO8601 } from '../helpers/dates';
import { TabSlug } from '../types';

export const SET_FOCUSED_ACCOUNT_ID = 'ACCOUNT_PERFORMANCE_REPORTING/SET_FOCUSED_ACCOUNT_ID';
export const SET_OPTIONS = 'ACCOUNT_PERFORMANCE_REPORTING/SET_OPTIONS';

export const SET_PERIOD = 'ACCOUNT_PERFORMANCE_REPORTING/SET_PERIOD';
export const SET_POSITIONS_DATE = 'ACCOUNT_PERFORMANCE_REPORTING/SET_POSITIONS_DATE';

export const UPDATE_TRANSACTION_FILTERS =
  'ACCOUNT_PERFORMANCE_REPORTING/UPDATE_TRANSACTION_FILTERS';

export const GROUP_SELECTION_DEFAULT_TAB_INDEX_SET =
  'WIDGETS/GROUP_SELECTION_DEFAULT_TAB_INDEX_SET';
export const GROUP_SELECTION_SELECTED_TAB_INDEX_SET =
  'WIDGETS/GROUP_SELECTION_SELECTED_TAB_INDEX_SET';
export const GROUP_SELECTION_TABS_LIST_SET = 'WIDGETS/GROUP_SELECTION_TABS_LIST_SET';
export const GROUP_SELECTION_TABS_LIST_LOADING_SET =
  'WIDGETS/GROUP_SELECTION_TABS_LIST_LOADING_SET';

export const setPeriod = payload => ({
  type: SET_PERIOD,
  payload,
});

export const setPositionsDate = payload => ({
  type: SET_POSITIONS_DATE,
  payload,
});

export const updateTransactionFilters = payload => ({
  type: UPDATE_TRANSACTION_FILTERS,
  payload,
});

export const setFocusedAccountId = accountId => ({
  type: SET_FOCUSED_ACCOUNT_ID,
  payload: { accountId },
});

const setOptions = options => ({ type: SET_OPTIONS, payload: { options } });

export const fetchWidgetsOptions = clientId => async dispatch => {
  const response = await fetchWithDefaults(
    `/Consumer/OrionAccountsWidgets${qs.stringify(
      { clientId, localDate: dateToISO8601() },
      { addQueryPrefix: true },
    )}`,
  );

  if (response.ok) {
    const { success, payload } = await response.json();

    if (success) {
      const {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        viewData: { reportingState, ...options },
      } = payload;

      dispatch(setOptions({ ...options }));
    }
  }
};

export const setGroupSelectionDefaultTabIndex = (tabIndex: number, tabSlug: TabSlug) => ({
  type: GROUP_SELECTION_DEFAULT_TAB_INDEX_SET,
  payload: { tabIndex, tabSlug },
});

export const setGroupSelectionSelectedTabIndex = (tabIndex: number, tabSlug: TabSlug) => ({
  type: GROUP_SELECTION_SELECTED_TAB_INDEX_SET,
  payload: { tabIndex, tabSlug },
});

export const setGroupSelectionTabsList = (tabList: string[], tabSlug: TabSlug) => ({
  type: GROUP_SELECTION_TABS_LIST_SET,
  payload: { tabList, tabSlug },
});

export const setGroupSelectionLoadingStatus = (isLoading: boolean, tabSlug: TabSlug) => ({
  type: GROUP_SELECTION_TABS_LIST_LOADING_SET,
  payload: { isLoading, tabSlug },
});
